import IconClose from "./close.svg?react";
import "./index.scss";
import Mask from "@components/Mask";
import { useAppSelector } from "@hooks/redux";
import { Turnstile } from "@marsidev/react-turnstile";
import report from "@report";
import message from "@utils/message";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

interface CaptchaCloudflareProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  captchaVerifyCallback: (captchaCode: string) => void;
}

export const CaptchaCloudflare = ({ visible, setVisible, captchaVerifyCallback }: CaptchaCloudflareProps) => {
  const { t } = useTranslation();
  const refCaptcha = useRef<any>(null);
  const { language } = useAppSelector((state) => state.globalReducer);

  useEffect(() => {
    if (visible) {
      refCaptcha.current?.execute();
    } else {
      refCaptcha.current?.reset();
    }
  }, [visible]);

  return (
    <Mask visible={true} className={twMerge("Layout-GlobalRecaptcha-Mask", visible ? "visible" : "invisible")}>
      <div className="Layout-GlobalRecaptcha flex flex-col items-center gap-[30px]">
        <Turnstile
          ref={refCaptcha}
          options={{
            language: language.split("-")[0],
            execution: "execute",
          }}
          siteKey="0x4AAAAAABc1l3uHtjmnRrZm"
          onSuccess={(token) => {
            captchaVerifyCallback(token);
            setVisible(false);
            report.event("cloudflare_success");
          }}
          onError={() => {
            const toastText = t('Oops, something seems to be wrong, please "refresh the page" and try again.');
            message.info(toastText);
            report.event("cloudflare_error");
          }}
        />
        <IconClose className="icon-close" onClick={() => setVisible(false)}></IconClose>
      </div>
    </Mask>
  );
};
